import { BaseTenantSearch } from '@/services/_base/BaseTenantSearch.ts'
import { type Task } from '@/types/Task.ts'
import type { IFirestoreService } from '@/platform/firebase/firestore'

type Session = { tenantId?: string; yardId?: string; userId?: string }

export class TaskSearch extends BaseTenantSearch<Task> {
  constructor(session: Session, firestore: IFirestoreService) {
    super('tasks', session, 'task.search', firestore)
  }

  /** Filter to overdue tasks (dueAt < today, status != done) */
  overdue() {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    this.where('dueAt', '<', today)
    this.where('status', '!=', 'done')
    this.orderBy('dueAt', 'desc') // Oldest overdue first
    this.appendToMetaName('overdue')
    return this
  }

  /** Filter to todo tasks (status == todo, dueAt >= today) */
  todo() {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    this.where('status', '==', 'todo')
    this.where('dueAt', '>=', today)
    this.orderBy('dueAt', 'asc')
    this.appendToMetaName('todo')
    return this
  }

  /** Filter to in-progress tasks (status == doing) */
  inProgress() {
    this.where('status', '==', 'doing')
    this.orderBy('dueAt', 'asc')
    this.appendToMetaName('inProgress')
    return this
  }

  /** Filter to done tasks (status == done) */
  done() {
    this.where('status', '==', 'done')
    this.orderBy('dueAt', 'desc')
    this.appendToMetaName('done')
    return this
  }

  /** Filter by person */
  byPerson(personId: string) {
    this.where('personId', '==', personId)
    this.appendToMetaName('byPerson')
    return this
  }

  /** Filter by organization */
  byOrganization(organizationId: string) {
    this.where('organizationId', '==', organizationId)
    this.appendToMetaName('byOrganization')
    return this
  }

  /** Filter by assigned user */
  byAssignedTo(userId: string) {
    this.where('assignedTo', '==', userId)
    this.appendToMetaName('byAssignedTo')
    return this
  }
}
